//@flow
import React from 'react';
import {Link} from 'react-router-dom';
import {makeStyles, Typography} from '@material-ui/core';

import SwitchableSection from '../../../../../elements/SwitchableSection';
import {HOME_PAGE_SECTION_NAMES} from '../../../utils/home-page-sections/constants';
import CustomButton from '../../../../../elements/CustomButton/CustomButton';
import {colors} from '../../../../../assets/styles/colors';
import {useFaqQuestion} from '../../../../configure/legal/utils/useStorePoliciesAndPrivacy';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '.75rem',
  },
  disabledRoot: {
    background: colors.grey300,
  },
  text: {
    fontSize: '.875rem',
    marginBlock: '1rem',
  },
}));

type Props = {
  sectionEnabled?: boolean,
};

export default function FaqSection(props: Props) {
  const {sectionEnabled} = props;
  const classes = useStyles();

  const {faqQuestions} = useFaqQuestion();

  const emptyContent = !faqQuestions?.length;

  return (
    <SwitchableSection
      id={HOME_PAGE_SECTION_NAMES.FAQ}
      title="Sección de preguntas frecuentes"
      subtitle="Muestra las preguntas frecuentes en tu página de inicio."
      classes={{
        root: emptyContent || !sectionEnabled ? classes.disabledRoot : '',
      }}
    >
      <Typography className={classes.text}>
        Tiene {faqQuestions?.length} preguntas frecuentes
      </Typography>
      <CustomButton
        className={classes.button}
        variant="contained"
        component={Link}
        target="_blank"
        rel="noopener noreferrer"
        to="/my-store/pages/legal/faq"
      >
        Ir a la seción de preguntas frecuentes
      </CustomButton>
    </SwitchableSection>
  );
}
